import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Crown, Users, ArrowLeft } from 'lucide-react';

const RoleSelection = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-4">
      <div className="w-full max-w-lg text-center">
        {/* Logo */}
        <div className="flex items-center justify-center mb-8">
          <div 
            className="flex items-center justify-center bg-white shadow-lg overflow-hidden"
            style={{
              width: '96px',
              height: '96px',
              borderRadius: '50%',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
            }}
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_refined-login/artifacts/7hacqtlv_Success%20Club%20Logo%20Files%20-%203%20%281%29.png" 
              alt="Success Club Logo" 
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                scale: '1.1'
              }}
            />
          </div>
        </div>

        <h1 className="text-3xl font-bold mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
          Let's get started
        </h1>
        <p className="text-gray-300 mb-12 text-lg">
          Choose an option to continue
        </p>

        <div className="space-y-6">
          {/* Member Option */}
          <div className="bg-gray-900 border border-gray-800 rounded-lg p-8 hover:border-blue-500 transition-colors">
            <div className="flex items-center justify-center mb-4">
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)'
              }}>
                <Users className="w-10 h-10 text-white" />
              </div>
            </div>
            <h3 className="text-xl font-semibold mb-2">For Members</h3>
            <p className="text-gray-400 mb-6">
              Join our exclusive network of entrepreneurs and business leaders
            </p>
            <div className="space-y-3">
              <Button
                onClick={() => navigate('/signup/member')}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white"
              >
                Join as Member
              </Button>
            </div>
          </div>

          {/* Host Option */}
          <div className="bg-gray-900 border border-gray-800 rounded-lg p-8 hover:border-amber-500 transition-colors">
            <div className="flex items-center justify-center mb-4">
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #D4AF37 0%, #C29A4B 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(212, 175, 55, 0.3)'
              }}>
                <Crown className="w-10 h-10" style={{color: '#111111'}} />
              </div>
            </div>
            <h3 className="text-xl font-semibold mb-2">For Hosts</h3>
            <p className="text-gray-400 mb-6">
              Create and manage your own exclusive business community
            </p>
            <div className="space-y-3">
              <Button
                onClick={() => navigate('/signup/host')}
                className="w-full bg-amber-600 hover:bg-amber-700 text-white"
              >
                Become a Host
              </Button>
            </div>
          </div>

          {/* Unified Login Option */}
          <div className="bg-gray-900 border border-gray-800 rounded-lg p-6 hover:border-green-500 transition-colors">
            <h3 className="text-lg font-semibold mb-2 text-center">Already a Member?</h3>
            <p className="text-gray-400 mb-4 text-center text-sm">
              Access your Success Club account
            </p>
            <Button
              onClick={() => navigate('/login')}
              variant="outline"
              className="w-full border-green-500 text-green-400 hover:bg-green-500/10"
            >
              Login to Success Club
            </Button>
          </div>
        </div>

        <div className="mt-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-gray-400 hover:text-white text-sm mx-auto"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer className="auth-footer">
        <div className="auth-footer-content">
          <div className="auth-footer-links">
            <a href="/features">Features</a>
            <a href="/events">Events</a>
            <a href="/magazine">Magazine</a>
            <a href="/pricing">Pricing</a>
            <a href="/contact">Contact</a>
            <a href="/help-center">Help</a>
            <a href="/privacy-policy">Privacy</a>
          </div>
          <div className="auth-footer-copy">
            © 2025 Success Club. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RoleSelection;